var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.env)?_c('div',{staticClass:"sticky-top border pt-1 px-4 bg-light small text-dark text-center",staticStyle:{"height":"2rem"}},[_c('strong',[_vm._v("\n    User Acceptance Testing - v"+_vm._s(_vm.ver)+" "+_vm._s(_vm.env)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5e626f4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/banner-environment.vue
// module id = null
// module chunks = 